import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from 'react-router-dom';

import FetchModule from "../../../Model/Network/FetchModule";
import WodTitleBox from "../Model/WodTitleBox";

import CrownIcon from '../../../Image/CrownIcon.png';


export default function NotePage(props) {

  const params = useParams();
  const navigate = useNavigate();

  const [events, setEvents] = useState([]);

  // 와드 정보 불러오기 //
  useEffect(() => {
    // const fetchModule = new FetchModule();
    // (
    //   async () => {
    //     const responseData = await fetchModule.getDataOfEventVer2('wod/', 'GET');
    //     // console.log(responseData.data);
    //     if (responseData.status === 200) {
    //       setEvents(responseData.data);
    //     }
    //   }
    // )();
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataOfEventVer2('wod/' + params.organizerId, 'GET');
        // console.log(responseData.data);
        if (responseData.status === 200) {
          setEvents(responseData.data);
        }
      }
    )();
  }, [params]);

  // 와드 저장하기 //
  function onClickAdditionWodButton(data) {
    let requestData = {
      eventId: data.eventId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfEventVer2('wod/add', 'POST', requestData);
        // console.log(responseData.data);
        if (responseData.status === 200) {
          setEvents(responseData.data);
        }
      }
    )();
  }

  // 와드 삭제 클릭시 //
  function onClickDeleteWodButton(data) {
    let requestData = {
      wodId: data.wodId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfEventVer2('wod/delete', 'POST', requestData);
        // console.log(responseData.data);
        if (responseData.status === 200) {
          setEvents(responseData.data);
        }
      }
    )();
  }

  // 와드 위로 올리기 클릭시 //
  function onClickUpWodButton(data) {
    if (data.viewIndex === 1) return;

    let requestData = {
      wodId: data.wodId,
      viewIndex: data.viewIndex
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfEventVer2('wod/up_view_index', 'POST', requestData);
        // console.log(responseData.data);
        if (responseData.status === 200) {
          setEvents(responseData.data);
        }
      }
    )();
  }

  // 와드 아래로 내리기 클릭시 //
  function onClickDownWodButton(data, maxLegnth) {
    if (data.viewIndex >= maxLegnth) return;

    let requestData = {
      wodId: data.wodId,
      viewIndex: data.viewIndex
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfEventVer2('wod/down_view_index', 'POST', requestData);
        // console.log(responseData.data);
        if (responseData.status === 200) {
          setEvents(responseData.data);
        }
      }
    )();
  }

  // 와드 클릭시 //
  function onClickWod(data) {
    navigate('/wod/' + data.eventId + '/' + data.wodId);
  }

  // 리더보드 버튼 클릭시 //
  function onClickLeaderBoardButton(data) {
    navigate('/leaderboard/' + data.eventId);
  }

  return (
    <TopLevelWrapper>
      <TotalEventWrapper>
        {
          events.map((data, index) => (
            <EventInfoWrapper key={'EventInfo-' + index}>
              <EventProfileBoxWrapper>
                <EventProfileBox>
                  <Profile src={data.eventProfile}/>
                </EventProfileBox>
                <EventNameBox>
                  <EventNameWrapper>
                    <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#FFFFFF' hover='default'>{data.eventTitle}</Text>
                  </EventNameWrapper>
                </EventNameBox>
              </EventProfileBoxWrapper>
              <EventWodBox>
                <WodBoxTextWrapper>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>이벤트 와드</Text>
                </WodBoxTextWrapper>
                <TotalWodBoxWrapper>
                  {
                    data.wods.map((wod, wodIndex) => (
                      <WodBoxWrapper key={'WodIndex-' + wodIndex}>
                        <WodTitleBox 
                          data={wod}
                          wodsLength={data.wods.length}
                          onClickDeleteWodButton={onClickDeleteWodButton}
                          onClickUpWodButton={onClickUpWodButton}
                          onClickDownWodButton={onClickDownWodButton}
                          onClickWod={onClickWod}/>
                      </WodBoxWrapper>
                    ))
                  }
                {
                  data.wods.length > 0 &&
                  <LeaderboardButton onClick={() => onClickLeaderBoardButton(data)}>
                    <CrownBox src={CrownIcon}/>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>LEADERBOARD</Text>
                  </LeaderboardButton>
                }
                </TotalWodBoxWrapper>
                <WodAdditionButton onClick={() => onClickAdditionWodButton(data)}>
                  <PlusWrapper>
                    <PlusStick width={14} height={2} />
                    <PlusStick width={2} height={14} />
                  </PlusWrapper>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>와드 추가</Text>
                </WodAdditionButton>
              </EventWodBox>
            </EventInfoWrapper>
          ))
        }
      </TotalEventWrapper>
    </TopLevelWrapper>
  );
}
 
const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 100%;
`;

const TotalEventWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  flex-wrap: wrap;

  width: 100%;

  gap: 30px;
`;

const EventInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: calc(50% - 30px);
  gap: 10px;
`;

const EventProfileBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: calc(50% - 5px);

  gap: 10px;
`;

const EventProfileBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: auto;

  border-radius: 24px;

  overflow: hidden;
`;

const Profile = styled.img`
  width: 100%;
`;

const EventNameBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  padding: 10px;

  width: calc(100% - 20px);
  height: 20px;
  
  overflow: hidden;

  border-radius: 10px;
  background-color: #2F2F32;
`;

const EventNameWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  text-align: center;

  width: 100%;
  height: 100%;

  overflow: hidden;
`;

const EventWodBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 8px 20px 20px 20px;

  width: 50%;

  border-radius: 20px;
  background-color: #17171B;
`;

const WodBoxTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
`;

const TotalWodBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 16px;

  width: 100%;

  gap: 10px;
`;

const WodBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const LeaderboardButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 40px;

  gap: 10px;

  border-radius: 10px;
  background-color: #FFB800;

  :hover {
    cursor: pointer;
  }
`;

const CrownBox = styled.img`
  width: 19px;
  height: 19px;
`;

const WodAdditionButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 30px;

  width: calc(100% - 4px);
  height: 36px;

  gap: 10px;

  border: 2px dashed #2F2F32;
  border-radius: 10px;

  :hover {
    cursor: pointer;
  }
`;

const PlusWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  :hover {
    cursor: pointer;
  }
`;

const PlusStick = styled.div`
  position: absolute;

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: 4px;
  background-color: #FFFFFF;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  :hover {
    cursor: ${props => props.hover};
  }
`;